import React from 'react';
import Datetime from '../components/Datetime';

function BooleanUpdate({ data }) {
    return <Datetime data={data} state={'normal'} />;
}

export default React.memo(BooleanUpdate);
